import React, {Component} from "react";
import {configMonthToDate, monthOptions, yearOptions} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { mapToDDL } from "../../../../common/mapper";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { transformResponseMTD } from "../config";
import * as R from "ramda";
class MonthToDateSalesReport extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            teamLead: null,
            tableConfig: configMonthToDate,
            dataTable1: [],
            dataTable2: [],
        };
    };

    componentDidMount() {
        this.handleSearch()
    };

    componentDidUpdate(prevProps, prevState) { 
        if(!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch ) {
            this.handleSearch();
        }
    } 

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async (isMergeLeasing) => {
        try {
            this.props.triggerLoading();
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanMTD,
                setError: this.props.setError,
                errorMessage: "Dashboard Level Kepala Cabang Keatas - Laporan Penjualan Bulanan",
                args: {
                    kodeCabang: [this.props.search?.value],
                    month: this.state.month?.value,
                    year: this.state.year?.value,
                    employeeIdTeamLeader: this.state.teamLead?.value,
                    mergerLeasing: isMergeLeasing
                },
            })
            this.props.onSuccessSearch()
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                if(!isMergeLeasing){
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataTable1: transformResponseMTD(res.data.data),
                    }));
                }else{
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataTable2: transformResponseMTD(res.data.data),
                    }));
                }
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("Error fetching data: ", error);
        }
    }

    handleSearch = () =>{
        this.fetchData();
        this.fetchData(true);
    }

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        isClearable
                        id="select_options_month"
                        box="search"
                        name="month"
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        isClearable
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        isClearable
                        id="select_options_team_leader"
                        box="search"
                        name="teamLead"
                        containerclassname="width width-250px"
                        placeholder="Nama TL"
                        menuPosition="fixed"
                        options={this.props.dataTL.map(item=>mapToDDL(item.salesLeadName, item.employeeId))}
                        value={this.state.teamLead}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "15px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <FlexView style={{gap: "50px"}}>
                    <SimpleDataTable
                        data={this.state.dataTable1}
                        columns={this.state.tableConfig}
                        options={{
                            serverSide: false,
                            rowsPerPage: 50,
                            rowsPerPageOptions: [],
                        }}
                    />
                    <SimpleDataTable
                        data={this.state.dataTable2}
                        columns={this.state.tableConfig}
                        options={{
                            serverSide: false,
                            rowsPerPage: 50,
                            rowsPerPageOptions: [],
                        }}
                    />
                </FlexView>
            </>
        );
    };
}

export default MonthToDateSalesReport;